import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface SelectableOptionProps {
    selected: boolean
    onClick: () => void
    children: ReactNode
    'data-testid'?: string
}

/**
 * Full-width clickable option row for inline pickers (search-result dropdowns,
 * selection lists). Left-aligned text, hover highlight, and a subtle primary
 * tint when selected. Use when you need a list of clickable alternatives but
 * don't want the weight of a Combobox or CommandList.
 */
export function SelectableOption({
    selected,
    onClick,
    children,
    'data-testid': testId,
}: SelectableOptionProps) {
    return (
        <button
            type="button"
            className={cn(
                'w-full text-left px-3 py-2 text-sm hover:bg-muted transition-colors',
                selected && 'bg-primary/10',
            )}
            onClick={onClick}
            data-testid={testId}
        >
            {children}
        </button>
    )
}
